"use strict";

import { useAlertStore } from "@/pinia";
import { useWalletStore } from "@/pinia";

// Wrapper function for fetch with 401 handling
async function fetchWithAuth(url, options = {}) {
  try {
    // Use the provided fetch function or the global fetch
    const fetchFn = options.fetch || fetch;
    const response = await fetchFn(url, options);

    if (response?.status === 401) {
      const alertStore = useAlertStore();
      const walletStore = useWalletStore();

      // Show session expired notification
      alertStore.error("Session Expired", "Please login again");

      // Clear auth token
      localStorage.removeItem("fluxbot:auth");
      localStorage.removeItem("walletName");

      // Clear wallet store
      walletStore.clearWallet();

      // Redirect to login page immediately
      window.location.href = "/auth/login";

      // Return empty response with 401 status to prevent further processing
      return new Response(null, { status: 401 });
    }

    return response;
  } catch (error) {
    console.error('Error:', error);
  }
}

// Export the wrapper function
export default fetchWithAuth; 